export const buildProvenance = { "commitHash": "c7fbd84e11ac1435db419d9fbfb0cd8edca17d09", "branchName": "refs/heads/release/2023.2", "buildDate": "2023-08-10T13:32:30.744Z", "version": "2023.2.13175" };
